import React from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'

import FailedToLoadResourceMsg from 'components/FailedToLoadResourceMsg'
import { getHumanReadable } from '@therms/web-common/utils/scheduleFrequency'
import Loading from '@therms/web-common/components/Loading'
import { makeSingleTaskRequestRoute } from '../shared/routePaths'
import RibbonField from 'components/RibbonField'
import TaskHeader from '../components/TaskHeader'
import TaskExecutions from '../TaskExecutions'

const Task = () => {
  const { taskId } = useParams()

  const { data: task, error } = useSWR(makeSingleTaskRequestRoute(taskId))

  if (error) return <FailedToLoadResourceMsg />

  if (!task) return <Loading />

  const { body, lastTaskExecution, occurrence, scheduleFrequency, title } = task

  return (
    <main className="shadow">
      <TaskHeader description={body} title={title} />

      <div className="flex flex-wrap">
        <RibbonField name="Occurrence" value={occurrence} />
        {scheduleFrequency && (
          <RibbonField name="Time" value={getHumanReadable(scheduleFrequency)} />
        )}
      </div>

      {!lastTaskExecution.taskExecutionId && (
        <div className="bg-light-100 list-entry-light p-2 text-center text-faded-300">
          <p>This task has not been yet completed</p>
        </div>
      )}

      <TaskExecutions taskId={taskId} />
    </main>
  )
}

export default Task
